import xfetch from '@ms/fetch'
import axios from 'crypto-fetch/axios.js'

/**
 * Fetches the global configuration from the backend and caches the response.
 *
 * @function
 * @returns {Promise<Object>} A promise that resolves to the global configuration data.
 */
export const fetchBonus = (planName = '') => {
  const options = {}
  if (planName) {
    options.planName = planName
  }
  const params = new URLSearchParams(options)
  return xfetch(`/marketing/market/bonus/valid?${params}`)
}

/**
 * 查询活动详情
 * @param {String} id 活动ID
 */
export const fetchActivityDetail = (id = '') => axios.get('/marketing/market/activity/detail', { params: { id } })

/**
 * 分享订单
 * @param {String} orderId  订单 id
 */
export const shareOrder = (orderId = '') => axios.get(`/marketing/market/activity/share/bet/${orderId}/share`)

/**
 * 查询活动的开始结束时间
 */
export const fetchShareOrderTime = () => axios.get('/marketing/market/activity/share/bet/time/check')

/**
 * 检查用户是否在黑名单
 */
export const fetchShareOrderUserValid = () => axios.get('/marketing/market/activity/share/bet/user/check')

/**
 * 获取积分榜红包计数牌
 * @param {String} activityId 活动id
 * @returns
 */
export const fetchMarketingVoucherStatistics = (activityId = '') => {
  return axios.get('/marketing/market/euro-cup/voucher/statistics', {
    params: { activityId }
  })
}
